import { auth } from "firebase";

/**
 * Contains the information needed for authorized operations.
 */
class AuthInfo {
  get id() {
    return auth().currentUser ? auth().currentUser.uid : null;
  }

  get emailVerified() {
    return auth().currentUser ? auth().currentUser.emailVerified : null;
  }

  /**
   * @returns {Promise<string>} Token for the current logged in user.
   */
  async getToken() {
    if (auth().currentUser) {
      return await auth().currentUser.getIdToken();
    }
    return null;
  }
}

export default AuthInfo;
